__turbopack_context__.v({
  "title": "TrafficSection-module-scss-module__CE8_Ka__title",
  "wrapper": "TrafficSection-module-scss-module__CE8_Ka__wrapper",
});
